<template>
    <div class="sidebar">
		<div class="hotspot">
			<sub-title title="热点专题"></sub-title>
			<div class="list">
				<el-carousel :interval="5000" arrow="always" height="150px">
				    <el-carousel-item v-for="item in hotspot" :key="item.id">
						<router-link :to="`/news-detail-${item.id}`" target="_blank">
							<el-image fit="cover" class="image" :src="$img(item.image)" @error="item.image = defaultGoodsImage" />
						</router-link>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- <div class="goods">
			<sub-title title="别人还看哪些"></sub-title>
			<div class="list"></div>
		</div> -->
		<div class="top-list">
			<sub-title title="点击排行"></sub-title>
			<div class="list">
				<div class="item" v-for="(item,i) in topList" :key="i">
					<router-link :to="`/news-detail-${item.id}`" target="_blank" >
						<span>{{i+1}}</span>
						<p>{{item.title}}</p>
					</router-link>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
	import {
		newsList,
		newsCat
	} from "@/api/cms/news";
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	
    export default {
        name: "sidebar",
        components: {
			SubTitle,
			DescText
        },
        props: {
            config: {
                type: Object,
                // required: true
            }
        },
        data() {
            return {
				hotspot:[],
				topList:[],
            }
        },
        created() {
			this.getHotspot()
			this.getTopList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            getHotspot(){
            	newsList({
            		cat_id:15,
            		page_size:3
            	}).then(res=>{
            		if (res.code == 0 && res.data) {
            			this.hotspot = res.data.list
            			// this.$set('tabs',this.tabs)
            		}
            	}).catch(err => {
            		this.$message.error(err.message);
            	});
            },
            getTopList(){
            	newsList({
            		// cat_id:15,
            		order:'hits desc',
            		page_size:10
            	}).then(res=>{
            		if (res.code == 0 && res.data) {
            			this.topList = res.data.list
            			// this.$set('tabs',this.tabs)
            		}
            	}).catch(err => {
            		this.$message.error(err.message);
            	});
            },
        },
        watch: {
            config: {
                handler: (e)=>{
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sidebar{
		width: 100%;
		overflow: hidden;
		.hotspot{
			.list{
				.image{
					width: 100%;
					height: 200px;
				}
				// .el-carousel__item h3 {
				// 	color: #475669;
				// 	font-size: 18px;
				// 	opacity: 0.75;
				// line-height: 300px;
				// 	margin: 0;
				// }
				// .el-carousel__item:nth-child(2n) {
				// 	background-color: #99a9bf;
				// }
				// .el-carousel__item:nth-child(2n+1) {
				// 	background-color: #d3dce6;
				// }
			}
		}
		.top-list{
			// overflow: hidden;
			.list{
				.item{
					display: block;
					// overflow: hidden;
					a{
						display: flex;
						overflow: hidden;
						span{
							// float: left;
							width: 35px;
							color: #686868;
							font-size: 20px;
							line-height: 30px;
							text-align: center;
						}
						p{
							flex: 1;
							line-height: 30px;
							overflow: hidden;
							text-overflow:ellipsis;
							white-space: nowrap;
						}
					}
				}
				.item:nth-child(-n+3) span{
					color: #c80026;
				}
			}
		}
	}
</style>
